<template>
  <main class="hud">
    <div class="scanlines" aria-hidden="true"></div>
    <div class="hud-grid" aria-hidden="true"></div>

    <header class="hud-top">
      <div class="hud-top__left">VOLMY // STAR OBSERVATORY</div>
      <div class="hud-top__center">SOLAR SURFACE FEED · GRANULATION</div>
      <div class="hud-top__right">SAFE MODE</div>
    </header>

    <section class="hud-center">
      <h1 class="hud-title">A STAR THAT BREATHES</h1>
      <p class="hud-sub">
        Convection · granulation · faculae. 
        <br/>
        Live, simulated, and within reach.</p>
      <div class="hud-actions">
        <a class="hud-btn primary" href="#">Engage</a>
        <a class="hud-btn ghost" href="#">Diagnostics</a>
      </div>
    </section>

    <aside class="hud-left" aria-label="telemetry">
      <div class="panel">
        <div class="panel-title">TELEMETRY</div>
        <ul class="kv">
          <li><span>TEMP</span><strong>5778 K</strong></li>
          <li><span>FLOW</span><strong>~2 km/s</strong></li>
          <li><span>RADIANCE</span><strong>1 L☉</strong></li>
          <li><span>BAND</span><strong>VISIBLE</strong></li>
        </ul>
        <div class="bars">
          <i style="--v:0.72"></i><i style="--v:0.35"></i><i style="--v:0.56"></i><i style="--v:0.18"></i><i style="--v:0.82"></i>
        </div>
      </div>
    </aside>

    <aside class="hud-right" aria-label="spectral">
      <div class="panel">
        <div class="panel-title">SPECTRAL BANDS</div>
        <div class="toggles">
          <button class="toggle on">H-ALPHA</button>
          <button class="toggle">Ca II K</button>
          <button class="toggle">WHITE</button>
        </div>
      </div>
      <div class="panel small">
        <div class="panel-title">CORE</div>
        <div class="dials">
          <div class="dial"><span>FUSION</span><strong>STABLE</strong></div>
          <div class="dial"><span>FIELD</span><strong>QUIET</strong></div>
        </div>
      </div>
    </aside>

    <footer class="hud-bottom">
      VOLMY · MASSIVE SIMULATED METAVERSE · STELLAR LAB · BUILD 0.1
    </footer>
  </main>
</template>

<script setup lang="ts">
// No script required; background is global
</script>

<style scoped>
.hud {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: grid;
  grid-template-areas:
    "top top top"
    "left center right"
    "bottom bottom bottom";
  grid-template-columns: 1fr minmax(320px, 880px) 1fr;
  grid-template-rows: auto 1fr auto;
  gap: 1.25rem;
  padding: 1.25rem;
}

.scanlines { position: absolute; inset: 0; background: repeating-linear-gradient(to bottom, rgba(255,255,255,0.03), rgba(255,255,255,0.03) 1px, transparent 2px, transparent 4px); mix-blend-mode: overlay; pointer-events: none; }
.hud-grid { position: absolute; inset: 0; background:
  linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px) 0 0/ 80px 100%,
  linear-gradient(to bottom, rgba(255,255,255,0.05) 1px, transparent 1px) 0 0/ 100% 80px; opacity: 0.15; pointer-events: none; }

.hud-top { grid-area: top; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; gap: 1rem; font-family: "Orbitron", ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica Neue, Arial; text-transform: uppercase; letter-spacing: 0.18em; font-size: 0.72rem; opacity: 0.8; }
.hud-top__left {
  justify-self: start;
  padding: 0.25rem 0.6rem;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 999px;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
}
.hud-top__center {
  justify-self: center;
  padding: 0.25rem 0.6rem;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 999px;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
}
.hud-top__right {
  justify-self: end;
  color: #ffb000;
  padding: 0.25rem 0.6rem;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 999px;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
}

.hud-center { grid-area: center; display: grid; place-items: center; text-align: center; gap: 0.9rem; padding: 1rem; }
.hud-title {
  font-family: "Orbitron", ui-sans-serif, system-ui, -apple-system;
  font-weight: 800;
  font-size: clamp(2rem, 5vw + 1rem, 4rem);
  letter-spacing: 0.04em;
  margin: 0;
  text-transform: uppercase;
  /* pill background */
  display: inline-block;
  padding: 0.35rem 1rem;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 999px;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
}
.hud-sub {
  max-width: 60ch;
  margin: 0 auto;
  opacity: 0.9;
  font-family: "Orbitron", ui-sans-serif, system-ui, -apple-system;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.9rem;
  /* pill background */
  display: inline-block;
  padding: 0.35rem 0.9rem;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 999px;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
}
.hud-actions { display: flex; gap: 0.75rem; justify-content: center; margin-top: 0.5rem; }
.hud-btn { font-family: "Orbitron", ui-sans-serif, system-ui, -apple-system; text-transform: uppercase; letter-spacing: 0.12em; font-size: 0.8rem; padding: 12px 18px; border-radius: 8px; text-decoration: none; border: 1px solid rgba(255,255,255,0.18); background: rgba(255,255,255,0.03); color: #e8e8f0; transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease; }
.hud-btn.primary { background: linear-gradient(90deg, #f7b267, #ff6f3c); color: #0b0b12; border-color: rgba(255,255,255,0.25); }
.hud-btn.ghost:hover, .hud-btn.primary:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(255,150,80,0.25); }

.hud-left { grid-area: left; align-self: center; }
.hud-right { grid-area: right; align-self: center; display: grid; gap: 1rem; }
.panel { backdrop-filter: blur(6px); background: rgba(0,0,0,0.28); border: 1px solid rgba(255,255,255,0.12); border-radius: 12px; padding: 0.9rem; }
.panel.small { padding: 0.7rem; }
.panel-title { font-family: "Orbitron", ui-sans-serif, system-ui, -apple-system; font-size: 0.75rem; letter-spacing: 0.16em; opacity: 0.9; margin-bottom: 0.5rem; }
.kv { list-style: none; margin: 0; padding: 0; display: grid; gap: 0.4rem; }
.kv li { display: flex; justify-content: space-between; font-size: 0.9rem; }
.kv span { opacity: 0.7; }
.kv strong { font-family: "Orbitron"; letter-spacing: 0.05em; }
.bars { display: grid; grid-auto-flow: column; gap: 0.25rem; align-items: end; height: 46px; margin-top: 0.5rem; }
.bars i { display: block; width: 6px; background: linear-gradient(#ffb000, #ff6f3c); height: calc(var(--v) * 46px); opacity: 0.9; border-radius: 3px; }

.toggles { display: flex; flex-wrap: wrap; gap: 0.4rem; }
.toggle { font-family: "Orbitron"; font-size: 0.72rem; letter-spacing: 0.12em; padding: 6px 10px; border-radius: 999px; border: 1px solid rgba(255,255,255,0.18); background: rgba(255,255,255,0.03); color: #dcdcf0; }
.toggle.on { background: linear-gradient(90deg, #ffd27b, #ff8e53); color: #111217; }

.dials { display: grid; grid-auto-flow: column; gap: 0.8rem; }
.dial { display: grid; gap: 0.2rem; }
.dial span { font-size: 0.7rem; letter-spacing: 0.16em; font-family: "Orbitron"; opacity: 0.7; }
.dial strong { font-family: "Orbitron"; }

.hud-bottom { grid-area: bottom; text-align: center; font-family: "Orbitron"; letter-spacing: 0.2em; font-size: 0.7rem; opacity: 0.6; padding-top: 0.5rem; }

@media (max-width: 900px) {
  .hud { grid-template-columns: 1fr minmax(260px, 1fr) 1fr; gap: 0.8rem; padding: 0.8rem; }
  .hud-left { display: none; }
  .hud-right { display: none; }
  .hud-title { font-size: clamp(1.8rem, 6vw + 1rem, 3rem); }
}
</style>
